/* eslint-disable no-underscore-dangle */
/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals

/**
 * Options editor with translate support for select input
 * @param {array} data
 * @param {labelKey} string (optional)
 * @param {valueKey} string (optional)
 * @param {nextTranslate} t (optional)
 * @returns {array}
 *
 * Example:
 *   Array.prototype.handleSelectOptions({
 *     data: [{name: "hede"}, {id: 11}],
 *     labelKey: "name",
 *     valueKey: "id",
 *   })
 */

import type { Translate } from "next-translate";

interface SelectOptionsParams {
  data: Record<string, unknown>[];
  labelKey?: string;
  valueKey?: string;
  tooltipKey?: string;
  groupKey?: string;
  t?: Translate;
}

Array.prototype.handleSelectOptions = ({
  data,
  labelKey,
  valueKey,
  tooltipKey,
  groupKey,
  t,
}: SelectOptionsParams): Record<string, unknown>[] => {
  const options: Record<string, unknown>[] = [];
  const _labelKey = labelKey ?? "label";
  const _valueKey = valueKey ?? "value";
  data.forEach((item) => {
    options.push({
      ...item,
      label: t ? t(String(item[_labelKey])) : item[_labelKey],
      value: item[_valueKey],
      groupKey: item[groupKey as string] ?? "",
      tooltipMessage: item[tooltipKey as string],
    });
  });

  return options;
};
